import './_product-benefits.scss';
import { gsap } from 'gsap';


window.addEventListener('DOMContentLoaded', function () {
    const iconBlockImages = document.querySelectorAll('.product-benefits__icon-image-wrapper');
    const section = document.querySelector('.product-benefits');

    let threshold;

    if (section) {
        threshold = section.getBoundingClientRect().top + window.scrollY - (window.innerHeight * 0.5);
    }

    iconBlockImages.forEach((icon) => {
        gsap.set(icon, { opacity: 0 });
    });

    function animateIconBlocks() {
        section.classList.add('is-animated');

        iconBlockImages.forEach((icon, index) => {
            const timeline = gsap.timeline({ delay: index * 0.5 });
            timeline.to(iconBlockImages[index], {  opacity: 1, scale: 1, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125 });
            timeline.to(iconBlockImages[index], {  opacity: 1, scale: 1.2, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125 });
            timeline.to(iconBlockImages[index], {  opacity: 1, scale: 1, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125 });
        });
    }

    window.addEventListener('scroll', function () {
        if (window.scrollY > threshold) {
            if (!section.classList.contains('is-animated')) {
                section.classList.add('is-animated');
                animateIconBlocks();
            }
        }
    });

    window.addEventListener('resize', function () {
        if (section) {
            let timeout = false;
            
            clearTimeout(timeout);

            timeout = setTimeout(function () {
                if (!section.classList.contains('is-animated')) {
                    // re-adjust animation trigger threshold if viewport changes
                    threshold = section.getBoundingClientRect().top + window.scrollY - (window.innerHeight * 0.5);
                }
            }, 25);
        }
    });
});